'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Link = function Link(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 30 30' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M13.9 19l-1.7 1.7c-.8.8-2.1.8-2.9 0-.8-.8-.8-2.1 0-2.9l3.3-3.3c.8-.8 2.1-.8 2.9 0 .3.3.9.3 1.2 0 .3-.3.3-.9 0-1.2-1.5-1.5-3.9-1.5-5.3 0l-3.3 3.3c-.7.7-1.1 1.6-1.1 2.6s.4 2 1.1 2.7c.7.7 1.7 1.1 2.7 1.1 1 0 1.9-.4 2.7-1.1l1.7-1.7c.3-.3.3-.9 0-1.2-.4-.3-1-.3-1.3 0m8-10.9c-1.5-1.5-3.9-1.5-5.3 0l-1.7 1.7c-.3.3-.3.9 0 1.2.3.3.9.3 1.2 0l1.7-1.7c.8-.8 2.1-.8 2.9 0 .8.8.8 2.1 0 2.9l-3.3 3.3c-.8.8-2.1.8-2.9 0-.3-.3-.9-.3-1.2 0-.3.3-.3.9 0 1.2.7.7 1.7 1.1 2.7 1.1 1 0 1.9-.4 2.7-1.1l3.3-3.3c1.4-1.4 1.4-3.8-.1-5.3'
      })
    )
  );
};
/*eslint-enable */

exports.default = Link;
//# sourceMappingURL=Link.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Link.js